<div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
	<img src="assets/img/loding.gif">
</div>
<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-lg-12 headboxes">
				<div class="card p-0">
					<div class="card-block p-0">
						<div class="heading-box" style="background-image: url(assets/img/blog.png);">
							<div class="row align-items-center">
								<div class="col-md-3">
									<div class="pagename">
										<h3 class="card-title">WEP Mentorship</h3>
									</div>
								</div>
								<div class="col-md-3">
									<div class="total-count">
										<h5 class="m-0">Total</h5>
										<h2>{{totalMentors}}</h2>
									</div>
								</div>
								<div class="col-md-3">
									<div class="total-count">
										<select class="form-control" id="approve_status" 
										[(ngModel)]="filterData.status" (change)="setFilterData($event)">
											<option value="ALL">ALL</option>
											<option value="PENDING">PENDING</option>
											<option selected value="APPROVED">APPROVED</option>								
											<option selected value="REJECTED">REJECTED</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-12">
				<div class="card">
					<div class="card-block">
						<div id="table" class="table-responsive">							
							<table datatable [dtOptions]="dtOptions" class="row-border hover">
								<thead>
								  <tr>
									<th>ID</th>
									<th>Name</th>
									<th>Email</th>
									<th>Mobile</th>
									<th>Status</th>
									<th>Action</th>
								  </tr>
								</thead>
								<tbody *ngIf="mentorList?.length != 0">
								  <tr *ngFor="let mentor of mentorList">
									<td>{{ mentor.id }}</td>
									<td>{{ mentor.name }}</td>
									<td>{{ mentor.email }}</td>
									<td>{{ mentor.mobile }}</td>
									<td>{{ mentor.approve_status}}</td>
									<td><button type="button" class="btn btn-eye" 
										(click)="openMentorInfo(mentor.action,mentorinfo_ind)">
										<i class="fa fa-eye"></i></button>
									</td>
								  </tr>
								</tbody>
								<tbody *ngIf="mentorList?.length == 0">
								  <tr>
									<td colspan="6" class="no-data-available">No data!</td>
								  </tr>
								</tbody>
							  </table>							  
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<ng-template #mentorinfo_ind let-c="close" let-d="dismiss" id="mentorinfo_ind">
			<div class="modal-info" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Mentor Information</h4>
						<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body">
						<form method="post" enctype="multipart/form-data" class="form-horizontal" #f="ngForm">
							<div class="row">
								<div class="col-lg-12">
									<table class="table table-bordered">
										<tbody>
											<tr>
												<th>First Name</th>
												<td>{{mentorInfo.first_name}}</td>
												<th>Last Name</th>
												<td>{{mentorInfo.last_name}}</td>
											</tr>
											<tr>
												<th>Email</th>
												<td>{{mentorInfo.email}}</td>
												<th>Mobile</th>
												<td>{{mentorInfo.mobile}}</td>
											</tr>
											<tr>
												<th>Birth Year</th>
												<td>{{mentorInfo.birth_yr}}</td>
												<th>Gender</th>
												<td>{{mentorInfo.gender}}</td>
											</tr>
											<tr>
												<th>Country</th>
												<td>{{mentorInfo.country_name}}</td>
												<th>State</th>
												<td>{{mentorInfo.state_name}}</td>
											</tr>
											<tr>
												<th>City</th>
												<td>{{mentorInfo.city_name}}</td>
												<th>Linkedin profile url</th>
												<td>{{mentorInfo.linkedin_profile_url}}</td>
											</tr>
											<tr>
												<th>Spoken Language</th>
												<td>{{mentorInfo.spoken_lang_names}}</td>
												<th>Primary Industry</th>
												<td>{{mentorInfo.primary_industry_name}}</td>
											</tr>
											<tr>
												<th>Stage of Enterprise</th>
												<td>{{mentorInfo.stage_of_enterprise_names}}</td>
												<th>Industry Experience</th>
												<td>{{mentorInfo.industry_experience_name}}</td>
											</tr>
											<tr>
												<th>Area of functional expertise</th>
												<td>{{mentorInfo.area_of_functional_expertise_name}}</td>
												<th>Qualification</th>
												<td>{{mentorInfo.qualification_name}}</td>
											</tr>
											<tr>
												<th>Preferred Track of Mentorship</th>
												<td>{{mentorInfo.track_of_mentorship_names}}</td>
												<th>Ecosystem Key</th>
												<td>{{mentorInfo.ecosystem_key_names}}</td>
											</tr>
											<tr>
												<th>Preference Across</th>
												<td>{{mentorInfo.preference_across_name}}</td>
												<th>Mode of Engagement</th>
												<td>{{mentorInfo.mode_of_engagement_name}}</td>
											</tr>
											<tr>
												<th>Willing no of mentees</th>
												<td>{{mentorInfo.willing_no_of_mentees_name}}</td>
												<th>No of hours per month</th>
												<td>{{mentorInfo.no_of_hours_per_month_name}}</td>
											</tr>
											<tr>
												<th>Profile Image</th>
												<td><img src="{{mentorInfo.profileimage}}" height="40px" width="50px"></td>
												<th>Resume</th>
												<td><a href="{{mentorInfo.document}}" target="_blank">Resume</a></td>
											</tr>
											<tr>
												<th>Status</th>
												<td>
													<select class="form-control" name="approve_status" id="approve_status" [(ngModel)]="mentorInfo.approve_status">
														<option disabled value="">Choose...</option>
														<option value="PENDING">Pending</option>
														<option value="APPROVED">Approve</option>
														<option value="REJECTED">Reject</option>
													</select>
												</td>
												<th>Remarks</th>
												<td>
													<input type="hidden" id="id" name="id" [(ngModel)]="mentorInfo.id">
													<textarea class="form-control" name="remarks" id="remarks" [(ngModel)]="mentorInfo.remark">{{mentorInfo.remark}}</textarea>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button type="submit" class="btn btn-primary" aria-label="Close"
							(click)="mentorStatusUpdate(this.mentorInfo,mentorinfo_ind)">Submit</button>
						<button type="button" class="btn btn-secondary" aria-label="Close"
							(click)="d('Cross click')">Close</button>
					</div>
				</div>
			</div>
		</ng-template>

	</div>
</div>